import { newStepValue } from '../../../services/flowBuilder/utils/constants';

const startNode = {
  json: {
    next: newStepValue,
    type: 'menu',
  },
  paths: ['next'],
  groups: [
    {
      Parameters: ['next'],
    },
  ],
  layout: {
    next: {
      type: 'next',
      label: 'Point to',
      validators: {
        optionSelected: true,
      },
    },
  },
};

export const startType = { start: startNode };
